import { connect } from 'react-redux';
import { fetchFilteredNewsAction } from 'app/ducks/filtered-news';
import FilterStories from 'app/components/partials/filter-stories';
import { withNavigate } from 'app/utilities/router-hoc';
import {
    selectFilteredNews,
    selectFilteredNewsCategory,
    selectFilteredNewsExcludeFeatured,
    selectFilteredNewsFirstPage,
    selectFilteredNewsIsBusy,
    selectFilteredNewsIsStale,
    selectFilteredNewsLastPage,
    selectFilteredNewsResultCount
} from 'app/selectors/filtered-news';

const mapStateToProps = (state) => ({
    currentCategory: selectFilteredNewsCategory(state),
    currentExcludeFeatured: selectFilteredNewsExcludeFeatured(state),
    firstPage: selectFilteredNewsFirstPage(state),
    isBusy: selectFilteredNewsIsBusy(state),
    isStale: selectFilteredNewsIsStale(state),
    items: selectFilteredNews(state),
    lastPage: selectFilteredNewsLastPage(state),
    resultCount: selectFilteredNewsResultCount(state)
});

const mapDispatchToProps = (dispatch) => ({
    loadData: (category, pages, mode, limit, excludeFeatured) =>
        dispatch(fetchFilteredNewsAction(category, pages, mode, limit, excludeFeatured))
});

export default withNavigate(connect(mapStateToProps, mapDispatchToProps)(FilterStories));
